/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WhiteListIP
 */
export interface WhiteListIP {
    /**
     * 
     * @type {string}
     * @memberof WhiteListIP
     */
    ipAddress?: string;
}

export function WhiteListIPFromJSON(json: any): WhiteListIP {
    return WhiteListIPFromJSONTyped(json, false);
}

export function WhiteListIPFromJSONTyped(json: any, ignoreDiscriminator: boolean): WhiteListIP {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ipAddress': !exists(json, 'ipAddress') ? undefined : json['ipAddress'],
    };
}

export function WhiteListIPToJSON(value?: WhiteListIP | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ipAddress': value.ipAddress,
    };
}

